import qs from 'qs';
import { requestJson } from 'src/utils/request';
import { getItem, setItem, removeItem } from 'ts/helpers/webStorage';
import { SSKeys } from 'ts/pages/lister/productNavigationHelper';

let PRODUCT_LINKS_RESPONSE;

const urlPathName = '/api/v1/shopping/productLinks';

function fetchProductLinks() {
  return new Promise((resolve, reject) => {
    const query = getItem(SSKeys.QueryString);
    if (query) {
      requestJson(`${urlPathName}?${query}`).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    } else {
      reject();
    }
  });
}

function setSessionLinks(productResponse) {
  setItem(SSKeys.ProductLinks, productResponse);
}

PRODUCT_LINKS_RESPONSE = getItem(SSKeys.ProductLinks);

export function getProductLinks() {
  return new Promise((resolve, reject) => {
    if (PRODUCT_LINKS_RESPONSE && PRODUCT_LINKS_RESPONSE.productLinks) {
      resolve(PRODUCT_LINKS_RESPONSE);
    } else {
      fetchProductLinks().then(
        (response) => {
          setSessionLinks(response);
          PRODUCT_LINKS_RESPONSE = response;
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    }
  });
}

export function handleProductLinksPageUpdate(newPageIndex) {
  const query = getItem(SSKeys.QueryString);
  const newQuery = qs.stringify({ ...qs.parse(query), page: newPageIndex });
  setItem(SSKeys.QueryString, newQuery);
  removeItem(SSKeys.ProductLinks);
  PRODUCT_LINKS_RESPONSE = {};
  return newQuery;
}
